import { EmojiAtom } from "../EmojiAtom/EmojiAtom";

export interface MapButtonProps {
  icon: React.ComponentProps<typeof EmojiAtom>["type"];
  color?:
    | "bg-SunriseYellow-4"
    | "bg-GeekBlue-4"
    | "bg-Cyan-4"
    | "bg-GoldenPurple-4"
    | "bg-PolarGreen-4"
    | "bg-DustRed-4";
}

export const MapButton: React.FC<MapButtonProps> = ({ icon, color }) => {
  return (
    <div
      className={`inline-flex h-8 w-8 items-center justify-center rounded-[500px] border-2 border-white shadow`}
    >
      <div
        className={`h-7 w-7 ${color} inline-flex items-center justify-center rounded-full`}
      >
        {icon && <EmojiAtom type={icon} />}
      </div>
    </div>
  );
};
